/**
 * APP 环境控制工具
 * 用于区分是否在 APP 内嵌 H5 环境
 */

/**
 * 判断是否在 APP WebView 环境中
 * 通过 APP 注入的 window.isAppWebView 变量判断
 * @returns {boolean}
 */
export function isAppEnvironment() {
  if (process.client) {
    // 使用 APP 注入的全局变量判断
    const isAppWebView = !!window.isAppWebView
    const hostname = window.location.hostname || ''
    const isSteamvoyDomain = hostname === 'steamvoy.store' || hostname.endsWith('.steamvoy.store')
    const isApp = isAppWebView || isSteamvoyDomain
    
    // 调试日志 - 打印变量值
    console.log('%c[APP环境检测]', 'color: #FF6B6B; font-weight: bold; font-size: 12px;', {
      'window.isAppWebView': window.isAppWebView,
      'isSteamvoyDomain': isSteamvoyDomain,
      'isApp': isApp,
      'hostname': hostname,
      'pathname': window.location.pathname,
      'userAgent': navigator.userAgent.substring(0, 100) + '...'
    })
    
    return isApp
  }
  return false
}

/**
 * 设置 APP 环境（调试用）
 * @param {boolean} isApp
 */
export function setAppEnvironment(isApp) {
  if (typeof window !== 'undefined') {
    window.isAppWebView = isApp
    console.log(`%c[APP环境设置]`, 'color: #4CAF50; font-weight: bold;', {
      'window.isAppWebView': isApp,
      '设置成功': true
    })
    // 触发环境变化事件
    window.dispatchEvent(new CustomEvent('app-env-change'))
  }
}

/**
 * 获取 APP 环境状态
 */
export function getAppEnvironment() {
  return isAppEnvironment()
}

// 在浏览器环境下，将控制函数暴露到 window 对象上，方便调试
if (typeof window !== 'undefined') {
  // 提供全局方法用于调试
  window.setAppEnv = setAppEnvironment
  window.isAppEnv = isAppEnvironment
  
  // 开发环境下显示调试信息
  console.log('%c[APP环境控制台]', 'color: #4CAF50; font-weight: bold;')
  console.log('📱 调试命令:')
  console.log('  window.setAppEnv(true)  - 模拟 APP 环境')
  console.log('  window.setAppEnv(false) - 模拟 H5 环境')
  console.log('  window.isAppEnv()       - 查看当前环境')
  console.log('  window.isAppWebView     - APP 注入的变量 (当前值: ' + window.isAppWebView + ')')
  
  // 打印当前环境状态
  setTimeout(() => {
    const currentEnv = isAppEnvironment()
    console.log(
      '%c[当前环境] ' + (currentEnv ? '🅰️ APP WebView' : '🌐 H5 浏览器'),
      'color: ' + (currentEnv ? '#FF5722' : '#2196F3') + '; font-weight: bold; font-size: 14px; padding: 4px 8px; border-radius: 4px; background: ' + (currentEnv ? '#FFE5E5' : '#E3F2FD'),
      {
        'window.isAppWebView': window.isAppWebView,
        'isApp': currentEnv
      }
    )
  }, 100)
}
